import { render, staticRenderFns } from "./ItemClassSelectMultiS.vue?vue&type=template&id=50cdcc28&"
import script from "./ItemClassSelectMultiS.vue?vue&type=script&lang=js&"
export * from "./ItemClassSelectMultiS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports